import { GET_MY } from '../../containers/App/constants';
import {
  FILTER_DEFAULT_LIMIT,
  REQUEST_ADD_INVOICE_RELATION_SOURCE,
  REQUEST_ADD_INVOICE_SUBJECT,
  REQUEST_ADD_INVOICE_VAT,
  REQUEST_CREATE_INVOICE,
  REQUEST_INVOICE,
  REQUEST_COMPANY_INVOICES,
  REQUEST_VEHICLE_INVOICES,
  REQUEST_INVOICE_SET_PARENT_INVOICE,
  REQUEST_INVOICE_SET_SUB_INVOICE,
  REQUEST_INVOICE_STATUS_LIST,
  REQUEST_INVOICES,
  REQUEST_INVOICES_SEARCH,
  REQUEST_RELATION_SOURCE_LIST,
  REQUEST_REMOVE_INVOICE_RELATION_SOURCE,
  REQUEST_REMOVE_INVOICE_SUBJECT,
  REQUEST_REMOVE_INVOICE_VAT,
  REQUEST_UPDATE_INVOICE,
  REQUEST_UPDATE_INVOICE_V2,
  INITIATE_INVOICE_EDIT,
  REQUEST_EXACT_EXPORT_INVOICE,
  REQUEST_VAT_CODES,
  REQUEST_EXACT_AUTH_STATUS,
  REQUEST_EXACT_AUTH_LINK,
  REQUEST_UPDATE_INVOICE_SUBJECT,
  REQUEST_COMPANY_TRANSPORT_LOCATIONS,
  REQUEST_INVOICE_FILTER,
  REQUEST_INVOICE_DOWNLOAD,
  REQUEST_AMOUNTS_CALCULATIONS,
  REQUEST_INVOICE_EMAIL,
  REQUEST_UPDATE_INVOICE_STATUS,
  REQUEST_INVOICE_DECLINE,
  REQUEST_SYNC_BPM,
  REQUEST_INVOICE_DELETE,
  REQUEST_CREATE_CREDIT_INVOICE,
  SET_EDIT_INVOICE_VALUE,
  FINALIZE_EXPORT_MAIL_INVOICE,
  GET_CURRENT_REST_BPM,
  REQUEST_UPDATE_INVOICE_DATE,
  REQUEST_PRODUCT_INVOICES,
  INITIATE_PRODUCT_INVOICE_CREATE,
  REQUEST_LEDGERS,
  REQUEST_UPDATE_INVOICE_OUTGOING_BPM,
  REQUEST_INVOICE_BARE,
  REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS,
  REQUEST_ADD_EXACT_WEBHOOK_SUBSCRIPTION,
  REQUEST_DELETE_EXACT_WEBHOOK_SUBSCRIPTION,
  REQUEST_UPDATE_INVOICE_GROSS_BPM,
  REQUEST_INVOICE_TRADE_IN_VEHICLES,
  REQUEST_LAST_PRODUCT_INVOICE_ID,
} from './constants';
import { random } from 'lodash';

export function fetchInvoices(offset = 0, limit = FILTER_DEFAULT_LIMIT) {
  return {
    type: REQUEST_INVOICE_FILTER,
  };
}

export function changeInvoiceFilter(name, value) {
  return {
    type: REQUEST_INVOICE_FILTER,
    name,
    value,
  };
}

export function fetchCompanyInvoices(companyId, text, offset = 0, callback) {
  const path = `invoice?offset=${offset}&limit=10&companyId=${companyId}${text ? `&text=${text}` : ''}`;
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_INVOICES,
    work: REQUEST_COMPANY_INVOICES,
    gate: REQUEST_COMPANY_INVOICES,
    path,
    callback,
  };
}

export function fetchProductInvoices(vehicleId, direction, callback) {
  const path = `/invoice/product-invoices/${vehicleId}/${direction}`;
  return {
    type: GET_MY,
    id: REQUEST_PRODUCT_INVOICES,
    work: REQUEST_PRODUCT_INVOICES,
    gate: REQUEST_PRODUCT_INVOICES,
    path,
    callback,
  };
}

export function fetchLatestProductInvoice(vehicleId, callback) {
  const path = `/invoice/product-invoices/invoice/get-last-created/${vehicleId}`;
  return {
    type: GET_MY,
    id: REQUEST_LAST_PRODUCT_INVOICE_ID,
    work: REQUEST_LAST_PRODUCT_INVOICE_ID,
    gate: REQUEST_LAST_PRODUCT_INVOICE_ID,
    path,
    callback,
  };
}

export function initiateProductInvoiceCreate() {
  return {
    type: INITIATE_PRODUCT_INVOICE_CREATE,
  };
}

export function fetchVehicleInvoices(vehicleId, text, offset = 0, callback) {
  let path = `invoice?offset=${offset}&limit=${10}${text ? `&text=${text}` : ''}`;
  path += `&filters[${0}][key]=vehicle_id&filters[${0}][type]=single&filters[${0}][value][${0}]=${vehicleId}`;
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_INVOICES,
    work: REQUEST_VEHICLE_INVOICES,
    gate: REQUEST_VEHICLE_INVOICES,
    path,
    callback,
  };
}

export function createInvoice(data, callback) {
  let path = `invoice`;
  if (data.applyDefaultTasks) {
    path = `${path}?applyDefaultTasks=true`;
    delete data.applyDefaultTasks;
  }

  return {
    type: GET_MY,
    id: REQUEST_CREATE_INVOICE,
    callback,
    work: REQUEST_CREATE_INVOICE,
    gate: REQUEST_CREATE_INVOICE,
    path,
    post: data,
  };
}

export function createProductInvoice(data) {
  return {
    type: GET_MY,
    id: REQUEST_CREATE_INVOICE,
    work: REQUEST_CREATE_INVOICE,
    gate: REQUEST_CREATE_INVOICE,
    path: `invoice`,
    post: data,
    putOnComplete: [fetchProductInvoices(data.separateInvoice.vehicleId, data.separateInvoice.direction)],
  };
}

export function updateInvoice(invoiceId, data, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_INVOICE,
    callback,
    work: REQUEST_UPDATE_INVOICE,
    gate: REQUEST_UPDATE_INVOICE,
    path: `invoice/${invoiceId}`,
    patch: data,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function updateInvoiceEmailData(invoiceId, data, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_INVOICE,
    callback,
    work: REQUEST_UPDATE_INVOICE,
    gate: REQUEST_UPDATE_INVOICE,
    path: `invoice/${invoiceId}`,
    patch: data,
  };
}

export function updateInvoiceV2(invoiceId, data, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_INVOICE_V2,
    callback,
    work: REQUEST_UPDATE_INVOICE_V2,
    gate: REQUEST_UPDATE_INVOICE_V2,
    path: `invoice/updateV2/${invoiceId}`,
    patch: data,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function initiateInvoiceEdit(id) {
  return {
    type: INITIATE_INVOICE_EDIT,
    id,
  };
}

export function setNewInvoiceValue(name, value) {
  return {
    type: SET_EDIT_INVOICE_VALUE,
    name,
    value,
  };
}

export function initiateNewInvoiceValue(name) {
  return {
    type: SET_EDIT_INVOICE_VALUE,
    name,
    initiate: true,
  };
}

export function resetInvoiceValues() {
  return {
    type: SET_EDIT_INVOICE_VALUE,
    reset: true,
  };
}

export function fetchStatuses(callback) {
  return {
    type: GET_MY,
    id: REQUEST_INVOICE_STATUS_LIST,
    callback,
    work: REQUEST_INVOICE_STATUS_LIST,
    gate: REQUEST_INVOICE_STATUS_LIST,
    path: `invoiceStatuses`,
  };
}

export function fetchRelationSources(callback) {
  return {
    type: GET_MY,
    id: REQUEST_RELATION_SOURCE_LIST,
    callback,
    work: REQUEST_RELATION_SOURCE_LIST,
    gate: REQUEST_RELATION_SOURCE_LIST,
    path: `relationSources`,
  };
}

export function fetchInvoice(invoiceId, callback = () => {}, options = { isUniqueGate: false }) {
  let gate = REQUEST_INVOICE + invoiceId;
  let work = options?.copyFromInvoiceId ? `${REQUEST_INVOICE}-${options?.copyFromInvoiceId}` : REQUEST_INVOICE
  if (options.isUniqueGate) gate += random(100);
  return {
    type: GET_MY,
    id: REQUEST_INVOICE,
    invoiceId,
    callback,
    work: work,
    gate,
    path: `invoice/${invoiceId}`,
  };
}

export function fetchInvoiceBare(invoiceId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_INVOICE_BARE,
    invoiceId,
    callback,
    work: REQUEST_INVOICE_BARE,
    gate: REQUEST_INVOICE_BARE + invoiceId,
    path: `invoice/${invoiceId}/bare`,
  };
}

export function addRelationSource(data, invoiceId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_ADD_INVOICE_RELATION_SOURCE,
    invoiceId,
    callback,
    post: data,
    work: REQUEST_ADD_INVOICE_RELATION_SOURCE,
    gate: REQUEST_ADD_INVOICE_RELATION_SOURCE,
    path: `invoice/${invoiceId}/relationSource`,
  };
}

export function removeRelationSource(sourceId, invoiceId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_REMOVE_INVOICE_RELATION_SOURCE,
    invoiceId,
    callback,
    delete: {},
    work: REQUEST_REMOVE_INVOICE_RELATION_SOURCE,
    gate: REQUEST_REMOVE_INVOICE_RELATION_SOURCE,
    path: `invoice/${invoiceId}/relationSource/${sourceId}`,
  };
}

export function addInvoiceSubject(data, invoiceId, callback) {
  let path = `invoice/${invoiceId}/subject`;
  if (data.applyDefaultTasks) {
    path = `${path}?applyDefaultTasks=true`;
    delete data.applyDefaultTasks;
  }

  return {
    type: GET_MY,
    id: REQUEST_ADD_INVOICE_SUBJECT,
    invoiceId,
    post: data,
    work: REQUEST_ADD_INVOICE_SUBJECT,
    gate: REQUEST_ADD_INVOICE_SUBJECT,
    path,
    putOnComplete: [fetchInvoice(invoiceId)],
    callback,
  };
}

export function updateInvoiceSubject(data, invoiceId, subjectId, callback) {
  let path = `invoice/${invoiceId}/subject/${subjectId}`;
  if (data.applyDefaultTasks) {
    path = `${path}?applyDefaultTasks=true`;
    delete data.applyDefaultTasks;
  }

  return {
    type: GET_MY,
    id: REQUEST_UPDATE_INVOICE_SUBJECT,
    invoiceId,
    patch: data,
    work: REQUEST_UPDATE_INVOICE_SUBJECT,
    gate: REQUEST_UPDATE_INVOICE_SUBJECT,
    path,
    putOnComplete: [fetchInvoice(invoiceId)],
    callback,
  };
}

export function removeInvoiceSubject(subjectId, invoiceId) {
  return {
    type: GET_MY,
    id: REQUEST_REMOVE_INVOICE_SUBJECT,
    invoiceId,
    delete: {},
    work: REQUEST_REMOVE_INVOICE_SUBJECT,
    gate: REQUEST_REMOVE_INVOICE_SUBJECT,
    path: `invoice/${invoiceId}/subject/${subjectId}`,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function updateInvoiceStatus(invoiceId, statusId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_INVOICE_STATUS,
    invoiceId,
    patch: {},
    work: REQUEST_UPDATE_INVOICE_STATUS,
    gate: REQUEST_UPDATE_INVOICE_STATUS,
    path: `invoice/${invoiceId}/status/${statusId}`,
    putOnComplete: [fetchInvoice(invoiceId)],
    callback,
  };
}

export function invoiceSearch(string, callback) {
  return {
    type: GET_MY,
    work: REQUEST_INVOICES_SEARCH,
    callback,
    path: `invoice?limit=100&text=${string}`,
  };
}

export function addParentInvoice(invoiceId, parentInvoiceId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_INVOICE_SET_PARENT_INVOICE,
    gate: REQUEST_INVOICE_SET_PARENT_INVOICE + invoiceId,
    post: {},
    path: `invoice/${invoiceId}/parentInvoice/${parentInvoiceId}`,
    callback,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function removeParentInvoice(invoiceId, parentInvoiceId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_INVOICE_SET_PARENT_INVOICE,
    gate: REQUEST_INVOICE_SET_PARENT_INVOICE + invoiceId,
    delete: {},
    path: `invoice/${invoiceId}/parentInvoice/${parentInvoiceId}`,
    callback,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function addSubInvoice(invoiceId, subInvoiceId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_INVOICE_SET_SUB_INVOICE,
    gate: REQUEST_INVOICE_SET_SUB_INVOICE + invoiceId,
    post: {},
    path: `invoice/${invoiceId}/subInvoice/${subInvoiceId}`,
    callback,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function removeSubInvoice(invoiceId, subInvoiceId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_INVOICE_SET_SUB_INVOICE,
    gate: REQUEST_INVOICE_SET_SUB_INVOICE + invoiceId,
    delete: {},
    path: `invoice/${invoiceId}/subInvoice/${subInvoiceId}`,
    callback,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function addInvoiceVat(invoiceId, dto, callback) {
  return {
    type: GET_MY,
    work: REQUEST_ADD_INVOICE_VAT,
    gate: REQUEST_ADD_INVOICE_VAT + invoiceId,
    post: dto,
    path: `invoice/${invoiceId}/vat`,
    callback,
  };
}

export function removeInvoiceVat(invoiceId, vatId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_REMOVE_INVOICE_VAT,
    gate: REQUEST_REMOVE_INVOICE_VAT + invoiceId,
    delete: {},
    path: `invoice/${invoiceId}/vat/${vatId}`,
    callback,
  };
}

export function exportInvoiceToExact(invoiceId) {
  return {
    type: GET_MY,
    work: REQUEST_EXACT_EXPORT_INVOICE,
    gate: REQUEST_EXACT_EXPORT_INVOICE + invoiceId,
    post: {},
    path: `/invoice/${invoiceId}/export`,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function finalizeV2(invoiceId, dto, callback) {
  dto = dto ?? {};
  return {
    type: GET_MY,
    work: REQUEST_EXACT_EXPORT_INVOICE,
    gate: REQUEST_EXACT_EXPORT_INVOICE + invoiceId,
    post: dto,
    path: `/invoice/${invoiceId}/finalizeV2`,
    putOnComplete: [fetchInvoice(invoiceId)],
    callback
  };
}

export function retryFinalizationV2(invoiceId) {
  return {
    type: GET_MY,
    work: REQUEST_EXACT_EXPORT_INVOICE,
    gate: REQUEST_EXACT_EXPORT_INVOICE + invoiceId,
    post: {},
    path: `/invoice/${invoiceId}/retry-finalizationV2`,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function getExactAuthStatus(callback) {
  return {
    type: GET_MY,
    id: REQUEST_EXACT_AUTH_STATUS,
    work: REQUEST_EXACT_AUTH_STATUS,
    gate: REQUEST_EXACT_AUTH_STATUS,
    path: `exact/auth-status`,
    callback,
  };
}

export function getExactAuthInitialLink(callback) {
  return {
    type: GET_MY,
    id: REQUEST_EXACT_AUTH_LINK,
    work: REQUEST_EXACT_AUTH_LINK,
    gate: REQUEST_EXACT_AUTH_LINK,
    path: `exact/auth-initial-link`,
    callback,
  };
}

export function getExactWebhookSubscriptions() {
  return {
    type: GET_MY,
    id: REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS,
    work: REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS,
    gate: REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS,
    path: `exact-webhook-subscriptions`,
  };
}

export function createWebhookSubscription(data) {
  return {
    type: GET_MY,
    id: REQUEST_ADD_EXACT_WEBHOOK_SUBSCRIPTION,
    work: REQUEST_ADD_EXACT_WEBHOOK_SUBSCRIPTION,
    gate: REQUEST_ADD_EXACT_WEBHOOK_SUBSCRIPTION,
    path: `exact-webhook-subscriptions`,
    post: data,
    putOnComplete: [getExactWebhookSubscriptions()],
  };
}

export function deleteWebhookSubscription(id) {
  return {
    type: GET_MY,
    id: REQUEST_DELETE_EXACT_WEBHOOK_SUBSCRIPTION,
    work: REQUEST_DELETE_EXACT_WEBHOOK_SUBSCRIPTION,
    gate: REQUEST_DELETE_EXACT_WEBHOOK_SUBSCRIPTION,
    path: `exact-webhook-subscriptions/${id}`,
    delete: {},
    putOnComplete: [getExactWebhookSubscriptions()],
  };
}

export function getVatCodes(callback) {
  return {
    type: GET_MY,
    id: REQUEST_VAT_CODES,
    work: REQUEST_VAT_CODES,
    gate: REQUEST_VAT_CODES,
    path: `/vat-code`,
    callback,
  };
}

export function fetchCompanyTransportLocations(companyId) {
  debugger;
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_TRANSPORT_LOCATIONS,
    work: REQUEST_COMPANY_TRANSPORT_LOCATIONS,
    gate: REQUEST_COMPANY_TRANSPORT_LOCATIONS,
    path: `company/${companyId}`,
  };
}

export function downloadInvoicePDF(invoiceId, callback, purchaseStatement) {
  const path = purchaseStatement ? `invoice/${invoiceId}/pdf?purchaseStatement=true` : `invoice/${invoiceId}/pdf`;
  return {
    type: GET_MY,
    work: `${REQUEST_INVOICE_DOWNLOAD}-${invoiceId}`,
    gate: `${REQUEST_INVOICE_DOWNLOAD}-${invoiceId}`,
    path,
    callback,
  };
}

export function downloadInvoicePurchase(invoiceId, callback) {
  return {
    type: GET_MY,
    work: `${REQUEST_INVOICE_DOWNLOAD}-${invoiceId}-ps`,
    gate: `${REQUEST_INVOICE_DOWNLOAD}-${invoiceId}-ps`,
    path: `invoice/${invoiceId}/pdf?purchaseStatement=true`,
    callback,
  };
}

export function downloadInvoiceTradeIn(invoiceId, callback) {
  return {
    type: GET_MY,
    work: `${REQUEST_INVOICE_DOWNLOAD}-${invoiceId}-trIn`,
    gate: `${REQUEST_INVOICE_DOWNLOAD}-${invoiceId}-trIn`,
    path: `invoice/${invoiceId}/pdf?tradeIn=true`,
    callback,
  };
}

export function calculateFinancialAmounts(dto, callback, loadInvoice) {
  console.log('dto', dto);
  return {
    type: GET_MY,
    work: REQUEST_AMOUNTS_CALCULATIONS,
    gate: REQUEST_AMOUNTS_CALCULATIONS,
    path: `invoice/subject/calculate-financial-amounts`,
    post: dto,
    callback,
  };
}

export function emailInvoice(invoiceId, emails, callback) {
  return {
    type: GET_MY,
    work: `${REQUEST_INVOICE_EMAIL}-${invoiceId}`,
    gate: REQUEST_INVOICE_EMAIL,
    path: `invoice/${invoiceId}/email`,
    post: { emails },
    callback,
  };
}

export function declineInvoice(invoiceId) {
  return {
    type: GET_MY,
    id: REQUEST_INVOICE_DECLINE,
    invoiceId,
    post: {},
    work: REQUEST_INVOICE_DECLINE,
    gate: REQUEST_INVOICE_DECLINE + invoiceId,
    path: `invoice/${invoiceId}/decline`,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function deleteInvoice(invoiceId, callback, properties, vehicleId, force) {
  return {
    type: GET_MY,
    id: REQUEST_INVOICE_DELETE,
    invoiceId,
    delete: { properties },
    work: REQUEST_INVOICE_DELETE,
    gate: REQUEST_INVOICE_DELETE + invoiceId,
    path: `invoice/${invoiceId}${force ? '?force=true' : ''}`,
    callback,
    putOnComplete: vehicleId ? [fetchVehicleInvoices(vehicleId)] : null,
  };
}

export function syncBpm(invoiceId) {
  return {
    type: GET_MY,
    id: REQUEST_SYNC_BPM,
    invoiceId,
    post: {},
    work: REQUEST_SYNC_BPM,
    gate: REQUEST_SYNC_BPM + invoiceId,
    path: `invoice/${invoiceId}/update-purchase-prices`,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function createCreditInvoice(invoiceId, properties, callback) {
  return {
    type: GET_MY,
    id: REQUEST_CREATE_CREDIT_INVOICE,
    invoiceId,
    post: { properties },
    work: REQUEST_CREATE_CREDIT_INVOICE,
    gate: REQUEST_CREATE_CREDIT_INVOICE + invoiceId,
    path: `invoice/${invoiceId}/credit-invoice`,
    putOnComplete: [fetchInvoice(invoiceId)],
    callback,
  };
}

export function getCurrentRestBpm(vehicleId, callback) {
  return {
    type: GET_MY,
    id: GET_CURRENT_REST_BPM,
    work: GET_CURRENT_REST_BPM,
    gate: GET_CURRENT_REST_BPM + vehicleId,
    path: `/vehicles/${vehicleId}/current-rest-bpm`,
    callback,
  };
}

export function finalizeAndExportInvoice(invoiceId, direction, email_address, callback) {
  const dto = direction == 'incoming' ? { email_address: 'ignored_email@gmail.com' } : { email_address };
  return {
    type: GET_MY,
    id: FINALIZE_EXPORT_MAIL_INVOICE,
    invoiceId,
    post: dto,
    work: FINALIZE_EXPORT_MAIL_INVOICE,
    gate: FINALIZE_EXPORT_MAIL_INVOICE + invoiceId,
    path: `invoice/${invoiceId}/export-email-invoice`,
    putOnComplete: [fetchInvoice(invoiceId)],
    callback,
  };
}

export function updateInvoiceDate(invoiceId, date) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_INVOICE_DATE,
    invoiceId,
    patch: { date },
    work: REQUEST_UPDATE_INVOICE_DATE,
    gate: REQUEST_UPDATE_INVOICE_DATE + invoiceId,
    path: `invoice/${invoiceId}/date`,
    putOnComplete: [fetchInvoice(invoiceId)],
  };
}

export function deleteProductInvoice(invoiceId, vehicleId, direction, callback) {
  return {
    type: GET_MY,
    id: REQUEST_INVOICE_DELETE,
    invoiceId,
    delete: {},
    work: REQUEST_INVOICE_DELETE,
    gate: REQUEST_INVOICE_DELETE + invoiceId,
    path: `invoice/${invoiceId}`,
    putOnComplete: [fetchProductInvoices(vehicleId, direction)],
    callback,
  };
}

export function getLedgers(callback) {
  return {
    type: GET_MY,
    id: REQUEST_LEDGERS,
    work: REQUEST_LEDGERS,
    gate: REQUEST_LEDGERS,
    path: `/ledger`,
    callback,
  };
}

export function updateInvoiceOutgoingBpm(invoiceId, value, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_INVOICE_OUTGOING_BPM,
    invoiceId,
    patch: { value },
    work: REQUEST_UPDATE_INVOICE_OUTGOING_BPM,
    gate: REQUEST_UPDATE_INVOICE_OUTGOING_BPM + invoiceId,
    path: `invoice/${invoiceId}/outgoing-bpm`,
    callback,
  };
}

export function updateInvoiceGrossBpm(invoiceId, value, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_INVOICE_GROSS_BPM,
    invoiceId,
    patch: { value },
    work: REQUEST_UPDATE_INVOICE_GROSS_BPM,
    gate: REQUEST_UPDATE_INVOICE_GROSS_BPM + invoiceId,
    path: `invoice/${invoiceId}/gross-bpm`,
    callback,
  };
}

export function getInvoiceTradeInVehicles(invoiceId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_INVOICE_TRADE_IN_VEHICLES,
    work: REQUEST_INVOICE_TRADE_IN_VEHICLES + invoiceId,
    gate: REQUEST_INVOICE_TRADE_IN_VEHICLES + invoiceId,
    path: `invoice/${invoiceId}/trade-in-vehicles`,
    callback,
  };
}
